/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { getSchemaTypeI18nKey } from '../../utils/typeUtils';
import { ADDITIONAL_PROPERTY_FLAG } from '../../utils/schemaUtils';
import { getParamRowId } from '../../utils/idUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H6 from 'UIComponents/elements/headings/H6';
import Code from 'UIComponents/elements/Code';
import DescriptionField from './DescriptionField';
import ValidRange from './shared/ValidRange';
import DescriptorBlock from './shared/DescriptorBlock';
import WrapIfAdditional from './shared/WrapIfAdditional';
export default class DefaultTemplate extends Component {
  renderConstraintValues() {
    const {
      schema
    } = this.props;

    if (schema.default == null && isNaN(schema.minimum) && isNaN(schema.maximum)) {
      return null;
    }

    let defaultValue = schema.default;

    if (typeof defaultValue !== 'string') {
      try {
        defaultValue = defaultValue.toString();
      } catch (e) {// Swallow error
      }
    }

    return /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-4",
      children: [schema.default != null && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H6, {
          className: "m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.defaultValue.header"
          })
        }), /*#__PURE__*/_jsx(Code, {
          children: defaultValue
        })]
      }), (!isNaN(schema.minimum) || !isNaN(schema.maximum)) && /*#__PURE__*/_jsx("div", {
        className: schema.default != null ? 'm-top-2' : null,
        children: /*#__PURE__*/_jsx(ValidRange, {
          schema: schema
        })
      })]
    });
  }

  render() {
    const {
      children,
      definitions,
      description,
      errors,
      id,
      label,
      onKeyChange,
      required,
      schema,
      schemaGroup,
      shouldDisplayLabel
    } = this.props;
    const isAdditionalProperty = schema.hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);

    if (!label || !shouldDisplayLabel) {
      return children;
    }

    return /*#__PURE__*/_jsx(WrapIfAdditional, Object.assign({}, this.props, {
      children: /*#__PURE__*/_jsx("div", {
        className: "params-row",
        "data-test-id": `schema-field-${getParamRowId(id)}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: "params-pair",
          children: [/*#__PURE__*/_jsx(DescriptorBlock, {
            description: description,
            id: id,
            isAdditionalProperty: isAdditionalProperty,
            label: label,
            onKeyChange: onKeyChange,
            required: required,
            schema: schema,
            schemaGroup: schemaGroup,
            schemaTypeI18nKey: getSchemaTypeI18nKey(schema, definitions)
          }), /*#__PURE__*/_jsxs("div", {
            className: "params-content",
            children: [description && /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(DescriptionField, {
                description: description,
                id: `${id}-description`
              })
            }), this.renderConstraintValues(), children, errors]
          })]
        })
      })
    }));
  }

}
DefaultTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  definitions: PropTypes.object,
  description: PropTypes.node,
  errors: PropTypes.element,
  id: PropTypes.string,
  label: PropTypes.string,
  onKeyChange: PropTypes.func,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string,
  shouldDisplayLabel: PropTypes.bool
};